import { DhlLoader as NewLoader } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for Loader component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const Loader = (props) => {
  const { variant, type, size, ...rest } = props;

  // Map old props to new props
  const newProps = {
    ...rest,
    variant,
    type,
    size,
  };

  return <NewLoader {...newProps} />;
};

Loader.propTypes = {
  variant: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
};

// Maintain static properties for backward compatibility
Loader.PRIMARY = "primary";
Loader.SUCCESS = "success";
Loader.RING = "ring";
Loader.RING_DONE = "ring-done";
Loader.REGULAR = "regular";

export default Loader;
